<img src="/assets/warn_triangle.svg" alt="">
<span class="flex-auto error-text">{{ errorText }}</span>
<button type="button"
        *ngIf="onButtonClick && buttonText"
        (click)="onButtonClick!()">{{ buttonText }}</button>
